import { createSelector } from 'reselect'
import { State } from '../../reducers/reducerType'

/**
 * Check if user settings were fetched
 * @param state The Redux state
 */

const getFetched = (state: State): boolean => state.userSettings.fetched

export default createSelector(
  [getFetched],
  (fetched) => {

    return fetched

  })
